// extracted by mini-css-extract-plugin
export default {"radio":"styles_radio__qZySG","checked":"styles_checked__dvqil"};